// extracted by mini-css-extract-plugin
module.exports = {"message":"FormSubHeader-module__message___1_ZdJ","subheader":"FormSubHeader-module__subheader___3Nyeq","error":"FormSubHeader-module__error___16aJy"};